export default __webpack_public_path__ + "static/media/aave-logo.e148933d.png";